import { useState } from "react";
import Button from "./Button";
import { ClickAwayListener } from "@mui/material";
import AboveTooltip from "./AboveTooltip";

interface IProps {
  text: JSX.Element | string;
  children: JSX.Element[];
  btnVariant: "contained" | "outlined";
  disabled?: false;
  className?: string;
  /** Native chart-tool-btn style (like PNG / Excel download). */
  toolButton?: boolean;
  title?: string;
}

const ExpandableButton = ({
  children,
  text,
  className,
  btnVariant = "contained",
  disabled = false,
  toolButton = false,
  title,
}: IProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const menu = isExpanded ? (
    <div className="absolute bg-white z-20 min-w-max right-0 py-3 px-2 rounded shadow-lg flex flex-col justify-start items-start gap-2">
      {children.map((child, i) => (
        <div
          className="whitespace-nowrap text-xs hover:text-sky-500 cursor-pointer"
          key={i}
        >
          {child}
        </div>
      ))}
    </div>
  ) : null;

  if (toolButton) {
    return (
      <ClickAwayListener onClickAway={() => setIsExpanded(false)}>
        <div className="relative w-fit">
          <AboveTooltip title={title}>
            <button
              type="button"
              className={`chart-tool-btn ${className || ""}`}
              aria-label={title}
              disabled={disabled}
              onClick={(e) => {
                e.stopPropagation();
                setIsExpanded(!isExpanded);
              }}
            >
              {text}
            </button>
          </AboveTooltip>
          {menu}
        </div>
      </ClickAwayListener>
    );
  }

  return (
    <ClickAwayListener onClickAway={() => setIsExpanded(false)}>
      <div className="w-full relative">
        <Button
          variant={btnVariant}
          onClick={() => setIsExpanded(!isExpanded)}
          text={text}
          disabled={disabled}
          className={className}
        />
        {menu}
      </div>
    </ClickAwayListener>
  );
};

export default ExpandableButton;
